import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosService } from '../../../../services/api'
import { createThunkName } from '../../../../utils/createThunkname'
import { BANNER_URLS } from '../../../../configs/api'
import {
  GetAllBannerResponse,
  GetAllBannerDetailResponse,
  GetBannerByIdResponse,
  CreateBannerDto,
  UpdateBannerDto,
  DeleteBannerDto,
  GetAllBannerDetailQueryParams
} from './types'

const PREFIX = 'banner'

export const BannerService = {
  getAllBannerAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'getAllBanner'), async () => {
    try {
      const result = await AxiosService.get<GetAllBannerResponse>(BANNER_URLS.getAllBanner)
      return result.data
    } catch (error) {
      throw error
    }
  }),
  getAllBannerDetailsAsyncThunk: createAsyncThunk(
    createThunkName(PREFIX, 'getAllBannerDetail'),
    async (queryParams: GetAllBannerDetailQueryParams) => {
      try {
        const result = await AxiosService.get<GetAllBannerDetailResponse>(BANNER_URLS.getAllBannerDetails, {
          params: queryParams
        })
        return result.data
      } catch (error) {
        throw error
      }
    }
  ),
  getBannerByIdAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'getBannerById'), async (bannerId: string) => {
    try {
      const result = await AxiosService.get<GetBannerByIdResponse>(BANNER_URLS.getBannerById(bannerId))
      return result.data
    } catch (error) {
      throw error
    }
  }),
  createBannerAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'createBanner'), async (dto: CreateBannerDto) => {
    try {
      await AxiosService.post(BANNER_URLS.createBanner, dto)
    } catch (error) {
      throw error
    }
  }),
  updateBannerAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'updateBanner'), async (dto: UpdateBannerDto) => {
    try {
      await AxiosService.put(BANNER_URLS.updateBanner, dto)
    } catch (error) {
      throw error
    }
  }),
  deleteBannerAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'deleteBanner'), async (dto: DeleteBannerDto) => {
    try {
      await AxiosService.post(BANNER_URLS.deleteBanner, dto)
    } catch (error) {
      throw error
    }
  })
}
